module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.getCurrentDiscussion.audio_discussion_is_enabled || (_vm.getCurrentDiscussion.audio_discussion_is_enabled && _vm.joinedAudioDiscussion)) ? _c('div', {
    staticClass: "flex bg-white flex-col space-y-2 lg:space-y-0 lg:flex-row justify-between items-center border border-solid border-gray-200 rounded-lg px-1.5 py-1.5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-1.5 flex-wrap md:flex-nowrap overflow-x-auto md:overflow-visible"
  }, [(_vm.discussion_is_live) ? _c('button', {
    staticClass: "border border-solid border-gray-300 hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": "Fullscreen",
      "title": "Fullscreen"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "relative border border-solid border-gray-300 hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3 py-1",
    attrs: {
      "aria-label": "Polls",
      "title": "Polls"
    },
    on: {
      "click": function($event) {
        return _vm.handleOpenPolls()
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-chart-pie mt-0.5"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("Polls")]), _vm._v(" "), (!_vm.hasTeacherPermissionsInCourse && _vm.polls_unawswered) ? _c('div', {
    staticClass: "absolute -top-1 -right-1 bg-pinky w-2 h-2 rounded-full"
  }) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "relative border border-solid border-gray-300 hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3 py-1",
    attrs: {
      "aria-label": "View Criteria",
      "title": "View Criteria"
    },
    on: {
      "click": function($event) {
        return _vm.handleOpenCriteria()
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), (_vm.discussion_is_live && _vm.getCurrentDiscussion.audio_discussion_is_enabled) ? _c('button', {
    staticClass: "border border-solid border-gray-300 hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3.5 py-1 disabled:opacity-50",
    attrs: {
      "disabled": _vm.isTappingOut,
      "aria-label": _vm.statusCamera ? 'Turn camera off' : 'Turn camera on',
      "title": _vm.statusCamera ? 'Turn camera off' : 'Turn camera on'
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeVideoStatus()
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid",
    class: _vm.statusCamera === true ? 'fa-video' : 'fa-video-slash text-red-500'
  })])]) : _vm._e(), _vm._v(" "), (_vm.present_in_circle && _vm.getCurrentDiscussion.audio_discussion_is_enabled) ? _c('button', {
    staticClass: "text-center w-8 md:w-12 h-8 rounded-md px-0 md:px-3.5 py-1 hover:bg-gray-100 text-gray-700 border border-solid border-gray-300 disabled:opacity-50",
    attrs: {
      "disabled": _vm.isTappingOut,
      "aria-label": _vm.statusMicro ? 'Unmute' : 'Mute',
      "title": _vm.statusMicro ? 'Unmute' : 'Mute'
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeMicroStatus()
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-center md:justify-start space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid",
    class: _vm.statusMicro === true ? 'fa-microphone-slash text-red-500' : 'fa-microphone ml-1'
  })])]) : _vm._e(), _vm._v(" "), (_vm.isCapturingTranscription === true) ? _c('div', {
    staticClass: "flex items-center px-2 text-gray-600"
  }, [_c('div', {
    staticClass: "flex items-center space-x-0.5 h-6 rounded-full w-5"
  }, _vm._l((3), function(n) {
    return _c('div', {
      key: n,
      staticClass: "w-1 bg-green-700 rounded-full transition-all duration-100",
      style: ({
        height: _vm.getBarHeight(n)
      })
    })
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.discussion_is_live) ? _c('div', {
    staticClass: "flex space-x-2 items-center flex-wrap md:flex-nowrap"
  }, [(!_vm.present_in_circle) ? _c('div', {
    staticClass: "flex items-center justify-center space-x-0.5 md:space-x-1.5"
  }, [_c('button', {
    staticClass: "hover:bg-primary disabled:opacity-50 text-primary px-2 md:px-3.5 py-1 h-8 rounded-md hover:text-white",
    attrs: {
      "disabled": _vm.disabledTapIn || _vm.teacher_tap_in,
      "aria-label": "New Idea",
      "title": "New Idea"
    },
    on: {
      "click": function($event) {
        return _vm.tapIn('new_idea')
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('button', {
    staticClass: "hover:bg-pinky disabled:opacity-50 hover:text-white px-2 md:px-3.5 py-1 h-8 rounded-md text-pinky",
    attrs: {
      "disabled": _vm.disabledTapIn || _vm.teacher_tap_in,
      "aria-label": "Challenge",
      "title": "Challenge"
    },
    on: {
      "click": function($event) {
        return _vm.tapIn('challenge')
      }
    }
  }, [_vm._m(3)]), _vm._v(" "), _c('button', {
    staticClass: "text-emerald-600 disabled:opacity-50 hover:bg-emerald-600 hover:text-white px-2 md:px-3.5 py-1 h-8 rounded-md",
    attrs: {
      "disabled": _vm.disabledTapIn || _vm.teacher_tap_in,
      "aria-label": "Build On",
      "title": "Build On"
    },
    on: {
      "click": function($event) {
        return _vm.tapIn('build_on')
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('button', {
    staticClass: "hover:bg-darkBlue-dark disabled:opacity-50 text-darkBlue-dark px-2 md:px-3.5 h-8 py-1 rounded-md hover:text-white",
    attrs: {
      "disabled": _vm.disabledTapIn || _vm.teacher_tap_in,
      "aria-label": "Question",
      "title": "Question"
    },
    on: {
      "click": function($event) {
        return _vm.tapIn('question')
      }
    }
  }, [_vm._m(5)])]) : _c('div', {
    staticClass: "flex items-center justify-center space-x-1 md:space-x-1.5"
  }, [_c('button', {
    staticClass: "bg-red-500 disabled:opacity-50 hover:bg-red-600 px-2 md:px-3.5 py-1 h-8 rounded-md text-white",
    attrs: {
      "disabled": _vm.isTappingOut === true,
      "aria-label": "Tap Out",
      "title": "Tap Out"
    },
    on: {
      "click": function($event) {
        return _vm.tapOutOfCircle()
      }
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "hidden sm:flex h-8 w-40 md:w-64"
  }, [(!_vm.edit_description_mode) ? _c('button', {
    staticClass: "text-xs text-gray-500 text-left hover:bg-gray-100 border border-solid border-gray-300 cursor-text rounded px-2 md:px-3.5 w-full h-full truncate",
    attrs: {
      "title": _vm.my_current_turn.description || _vm.my_turn_description_label
    },
    on: {
      "click": function($event) {
        return _vm.editDescription()
      }
    }
  }, [_c('i', {
    staticClass: "fa-solid fa-quote-left mr-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "truncate"
  }, [_vm._v(_vm._s(_vm.my_current_turn.description || _vm.my_turn_description_label))])]) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.turn_description),
      expression: "turn_description"
    }],
    ref: "descriptionInput",
    staticClass: "text-xs bg-input text-gray-500 outline-none px-2 w-full h-full rounded",
    attrs: {
      "type": "text",
      "maxlength": "70"
    },
    domProps: {
      "value": (_vm.turn_description)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.updateTurnDescription.apply(null, arguments)
      },
      "blur": _vm.updateTurnDescription,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.turn_description = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.current_speaker) ? _c('div', {
    staticClass: "flex items-center space-x-1"
  }, [(_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'New Idea') ? _c('button', {
    staticClass: "bg-primary disabled:opacity-50 px-2 md:px-3.5 py-1 h-8 rounded-md text-white",
    attrs: {
      "disabled": _vm.disabledTapIn || _vm.teacher_tap_in,
      "aria-label": "New Idea",
      "title": "New Idea"
    }
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'Challenge') ? _c('button', {
    staticClass: "bg-pinky disabled:opacity-50 text-white px-2 md:px-3.5 py-1 h-8 rounded-md",
    attrs: {
      "disabled": _vm.disabledTapIn || _vm.teacher_tap_in,
      "aria-label": "Challenge",
      "title": "Challenge"
    }
  }, [_vm._m(8)]) : _vm._e(), _vm._v(" "), (_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'Build On') ? _c('button', {
    staticClass: "bg-emerald-600 disabled:opacity-50 text-white px-2 md:px-3.5 py-1 h-8 rounded-md",
    attrs: {
      "disabled": _vm.disabledTapIn || _vm.teacher_tap_in,
      "aria-label": "Build On",
      "title": "Build On"
    }
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'Question') ? _c('button', {
    staticClass: "bg-darkBlue-dark disabled:opacity-50 px-2 md:px-3.5 h-8 py-1 rounded-md text-white",
    attrs: {
      "disabled": _vm.disabledTapIn || _vm.teacher_tap_in,
      "aria-label": "Question",
      "title": "Question"
    }
  }, [_vm._m(10)]) : _vm._e(), _vm._v(" "), (_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'Add by teacher') ? _c('button', {
    staticClass: "bg-orange disabled:opacity-50 px-2 md:px-3.5 h-8 py-1 rounded-md text-white",
    attrs: {
      "disabled": _vm.disabledTapIn || _vm.teacher_tap_in,
      "aria-label": "Add by teacher",
      "title": "Add by teacher"
    }
  }, [_vm._m(11)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.current_speaker) ? _c('div', [_c('pl-menu', {
    attrs: {
      "direction": "right",
      "menuSize": 3
    }
  }, [(_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'New Idea') ? _c('button', {
    staticClass: "bg-primary px-2 md:px-3.5 py-1 h-8 rounded-md text-white",
    attrs: {
      "slot": "menu_trigger"
    },
    on: {
      "mouseenter": function($event) {
        _vm.isCurrentTurnHover = true
      },
      "mouseleave": function($event) {
        _vm.isCurrentTurnHover = false
      }
    },
    slot: "menu_trigger"
  }, [_c('div', {
    staticClass: "flex justify-center items-center space-x-0 md:space-x-2"
  }, [(_vm.isCurrentTurnHover === false) ? _c('i', {
    staticClass: "fa-solid fa-play"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs"
  }, [_c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v(_vm._s(_vm.isCurrentTurnHover ? 'Change' : 'New Idea'))])])])]) : _vm._e(), _vm._v(" "), (_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'Challenge') ? _c('button', {
    staticClass: "bg-pinky text-white px-2 md:px-3.5 text-center py-1 h-8 rounded-md",
    attrs: {
      "slot": "menu_trigger"
    },
    on: {
      "mouseenter": function($event) {
        _vm.isCurrentTurnHover = true
      },
      "mouseleave": function($event) {
        _vm.isCurrentTurnHover = false
      }
    },
    slot: "menu_trigger"
  }, [_c('div', {
    staticClass: "flex text-center justify-center items-center space-x-0 md:space-x-2"
  }, [(_vm.isCurrentTurnHover === false) ? _c('i', {
    staticClass: "fa-solid fa-circle"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs"
  }, [_c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v(_vm._s(_vm.isCurrentTurnHover ? 'Change' : 'Challenge'))])])])]) : _vm._e(), _vm._v(" "), (_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'Build On') ? _c('button', {
    staticClass: "bg-emerald-600 text-white px-2 md:px-3.5 py-1 h-8 rounded-md",
    attrs: {
      "slot": "menu_trigger"
    },
    on: {
      "mouseenter": function($event) {
        _vm.isCurrentTurnHover = true
      },
      "mouseleave": function($event) {
        _vm.isCurrentTurnHover = false
      }
    },
    slot: "menu_trigger"
  }, [_c('div', {
    staticClass: "flex justify-center items-center space-x-0 md:space-x-2"
  }, [(_vm.isCurrentTurnHover === false) ? _c('i', {
    staticClass: "fa-solid fa-square"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs"
  }, [_c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v(_vm._s(_vm.isCurrentTurnHover ? 'Change' : 'Build On'))])])])]) : _vm._e(), _vm._v(" "), (_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'Question') ? _c('button', {
    staticClass: "bg-darkBlue-dark px-2 md:px-3.5 h-8 py-1 rounded-md text-white",
    attrs: {
      "slot": "menu_trigger"
    },
    on: {
      "mouseenter": function($event) {
        _vm.isCurrentTurnHover = true
      },
      "mouseleave": function($event) {
        _vm.isCurrentTurnHover = false
      }
    },
    slot: "menu_trigger"
  }, [_c('div', {
    staticClass: "flex items-center justify-center space-x-0 md:space-x-2"
  }, [(_vm.isCurrentTurnHover === false) ? _c('i', {
    staticClass: "fa-solid fa-circle-question"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs"
  }, [_c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v(_vm._s(_vm.isCurrentTurnHover ? 'Change' : 'Question'))])])])]) : _vm._e(), _vm._v(" "), (_vm.generateTurnPhrases(_vm.my_current_turn.turn_type).title === 'Add by teacher') ? _c('button', {
    staticClass: "bg-orange px-2 md:px-3.5 h-8 py-1 rounded-md text-white",
    attrs: {
      "slot": "menu_trigger"
    },
    on: {
      "mouseenter": function($event) {
        _vm.isCurrentTurnHover = true
      },
      "mouseleave": function($event) {
        _vm.isCurrentTurnHover = false
      }
    },
    slot: "menu_trigger"
  }, [_c('div', {
    staticClass: "flex items-center justify-center space-x-0 md:space-x-2"
  }, [(_vm.isCurrentTurnHover === false) ? _c('i', {
    staticClass: "fa-solid fa-chalkboard-user"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs"
  }, [_c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v(_vm._s(_vm.isCurrentTurnHover ? 'Change' : 'Add by teacher'))])])])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "text-xs overflow-x-hidden",
    attrs: {
      "menu-content": ""
    }
  }, _vm._l((_vm.turn_types), function(type) {
    return _c('li', {
      key: type,
      staticClass: "menu-option font-poppins",
      on: {
        "click": function($event) {
          return _vm.updateTurnType(type)
        }
      }
    }, [_c('button', {
      staticClass: "flex items-center w-full h-full disabled:opacity-50",
      attrs: {
        "disabled": _vm.disabledTapIn || _vm.teacher_tap_in || _vm.my_current_turn.turn_type === type
      }
    }, [_c('div', {
      staticClass: "mr-0.5 w-4",
      domProps: {
        "innerHTML": _vm._s(_vm.determineTurnTypeIconHTML(type, true))
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.generateTurnPhrases(type).title))])])])
  }), 0)])], 1) : _vm._e()])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-expand"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-list-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-play"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("New Idea")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("Challenge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("Build On")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-question"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("Question")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-up-from-bracket rotate-270"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("Tap Out")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-play"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("New Idea")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("Challenge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("Build On")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-question"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("Question")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-chalkboard-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-xs hidden md:inline"
  }, [_vm._v("Add By Teacher")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0cc4797c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/LDDiscussionStudentBar.vue
// module id = 1762
// module chunks = 61